const STORAGE_KEY = 'dworks.recovery.pkce.v1';
const MAX_AGE = 24 * 60 * 60 * 1000;
function base64url(bytes) {
  return btoa(String.fromCharCode(...bytes)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
export async function prepareRecoveryPkce(email, storage = localStorage) {
  const previous = readRecoveryPkce(storage);
  const verifier = previous?.email === email.trim().toLowerCase() ? previous.verifier : base64url(crypto.getRandomValues(new Uint8Array(32)));
  const challenge = base64url(new Uint8Array(await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier))));
  storage.setItem(STORAGE_KEY, JSON.stringify({ verifier, email: email.trim().toLowerCase(), createdAt: Date.now() }));
  return { code_challenge: challenge, code_challenge_method: 's256' };
}
export function readRecoveryPkce(storage = localStorage, now = Date.now()) {
  try {
    const value = JSON.parse(storage.getItem(STORAGE_KEY));
    return value && typeof value.verifier === 'string' && value.verifier.length >= 43 &&
      typeof value.email === 'string' && now >= value.createdAt && now - value.createdAt < MAX_AGE ? value : null;
  } catch { return null; }
}
export function clearRecoveryPkce(storage = localStorage) { storage.removeItem(STORAGE_KEY); }
export function recoveryCodeFromUrl(value) {
  try {
    const url = new URL(value);
    const allowed = (url.protocol === 'kr.dworks.app:' && url.host === 'auth' && url.pathname === '/recovery') ||
      (url.origin === 'https://app.d-works.kr' && url.pathname === '/reset-password');
    const code = url.searchParams.get('code');
    return allowed && code && /^[a-zA-Z0-9_-]{16,2048}$/.test(code) ? code : null;
  } catch { return null; }
}

